import type { canvClass } from "@/canv/canv";
import { type CursorTool, copyManager } from "@/tools/cursorTool";

// Универсальный переход из "copying" в "dragging" с доводкой позиции
export const switchCopyingToDragging = (canv: canvClass, cursor: CursorTool) => {
    const pt = canv.actionManager.getActionPoint();
    const selProps = canv.canvasController.getSelectedProps();
    const grab = copyManager.copyGrabOffset;
    if (!pt || !selProps || !grab) return;

    // целевая позиция левого-верхнего угла выделения при отпускании Alt
    const targetX = pt.x - grab.dx;
    const targetY = pt.y - grab.dy;
    const dx = targetX - selProps.startX;
    const dy = targetY - selProps.startY;

    cursor.turnMode("dragging");

    if (dx || dy) {
        const selected = canv.canvasController.selected;
        for (let i = 0; i < selected.length; i++) {
            selected[i].translateGroup(dx, dy);
        }
    }

    canv.widgetMenu?.hide?.();
};

export function isTextEditorPointerEvent(canv: canvClass, event: PointerEvent): boolean {
    if (!canv.textEditingController.getIsEditing()) {
        return false;
    }

    return event.composedPath().some((target) => {
        if (!(target instanceof Element)) {
            return false;
        }

        return target.classList.contains("editor-box") || target.classList.contains("ql-editor");
    });
}
